import React, { useState, useEffect } from "react";

export default function PickerModal({
    show,
    onHide,
    title,
    options = [],
    selected,
    onSelect,
}) {
    const [localSelected, setLocalSelected] = useState(selected || null);
    const isColorPicker = options?.[0]?.color; // detect color picker

    // Sync local selected value when modal opens


    // Confirm button
    const handleConfirm = () => {
        const found = options.find(
            (o) => o.label === localSelected || o.id === localSelected
        );
        if (found) onSelect(found);
        onHide();
    };

    // Close on outside click
    const handleOverlayClick = (e) => {
        if (e.target.classList.contains("picker-overlay")) {
            onHide();
        }
    };

    return (
        <>
            <style>{`
        .picker-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.45);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
        }
        .picker-modal {
          width: 50vw;
          max-width: 700px;
          background: #fff;
          border-radius: 16px;
          border: 1px solid #e5e7eb;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          animation: fadeIn 0.25s ease-in-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
        .picker-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 20px;
          border-bottom: 1px solid #e5e7eb;
        }
        .picker-title {
          font-size: 20px;
          font-weight: 500;
          color: #111827;
        }
        .picker-close {
          width: 32px;
          height: 32px;
          border: 1px solid #d5d8e1;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 18px;
          color: #111827;
          transition: all 0.2s ease-in-out;
        }
        .picker-close:hover {
          background: #f3f4f6;
        }
        .picker-body {
          padding: 20px;
          max-height: 400px;
          overflow-y: auto;
        }
        .picker-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
          justify-items: center;
        }
        .picker-item {
          border: 0.5px solid #DFE0E9;
          border-radius: 12px;
          background: #fff;
          width: 160px;
          min-height: 110px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease-in-out;
          padding: 12px;
        }
        .picker-item:hover {
          border-color: #5fa5a7;
          transform: scale(1.03);
        }
        .picker-item.selected {
          border: 2px solid #5fa5a7;
        }
        .picker-icon {
          width: 48px;
          height: 48px;
          object-fit: contain;
          margin-bottom: 8px;
        }
        .picker-color-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 1px solid #d1d5db;
          margin-bottom: 8px;
        }
        .picker-label {
          font-weight: 600;
          color: #111827;
          font-size: 14px;
          text-align: center;
        }
        .picker-footer {
          border-top: 1px solid #e5e7eb;
          padding: 16px;
          display: flex;
          justify-content: center;
        }
        .picker-confirm {
          min-width: 200px;
          background-color: #5fa5a7;
          color: #fff;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 500;
          padding: 10px 0;
          cursor: pointer;
          transition: background 0.2s ease-in-out;
        }
        .picker-confirm:hover {
          background-color: #4b8e90;
        }
        @media (max-width: 768px) {
          .picker-modal {
            width: 90vw;
          }
          .picker-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>

            {show && (
                <div className="picker-overlay" onClick={handleOverlayClick}>
                    <div className="picker-modal" dir={document.dir || "rtl"}>
                        {/* HEADER */}
                        <div className="picker-header">
                            <div className="picker-title">{title}</div>
                            <div className="picker-close" onClick={onHide}>
                                ✕
                            </div>
                        </div>

                        {/* BODY */}

                        <div className="picker-body">
                            <div className="picker-grid">
                                {options.map((opt) => {
                                    console.log("OPTION", opt.id, opt.label);
                                    return (
                                        (
                                            <div

                                                key={opt.id ?? opt.label}
                                                className={`picker-item ${localSelected === (opt.id ?? opt.label) ? "selected" : ""
                                                    }`}
                                                onClick={() => setLocalSelected(opt.id ?? opt.label)}


                                            >
                                                {isColorPicker ? (
                                                    <>
                                                        <div
                                                            className="picker-color-circle"
                                                            style={{ backgroundColor: opt.color }}
                                                        />
                                                        <span className="picker-label">{opt.label}</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        {opt.iconUrl && (
                                                            <img
                                                                src={opt.iconUrl}
                                                                alt={opt.label}
                                                                className="picker-icon"
                                                            />
                                                        )}
                                                        <span className="picker-label">{opt.label}</span>
                                                    </>
                                                )}
                                            </div>
                                        )
                                    )
                                })}
                            </div>
                        </div>

                        {/* FOOTER */}
                        <div className="picker-footer">
                            <button className="picker-confirm" onClick={handleConfirm}>
                                تأكيد
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
